// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Y+F0s","primary":"Button_primary__xATCt","dark":"Button_dark__8iwgL","outline":"Button_outline__yzxD0","fill":"Button_fill__tAZaH"};